import { c as _c } from "react/compiler-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Renders key facts about a feature as dot-separated text.
 * Used in both the map sidebar (PlaceDetail) and the place page (PlatsDetailView).
 */
export function FeatureFacts(t0) {
  const $ = _c(4);
  const {
    facts
  } = t0;
  if (facts.length === 0) {
    return null;
  }
  let t1;
  if ($[0] !== facts) {
    t1 = facts.map(_temp).join(" \xB7 ");
    $[0] = facts;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = /*#__PURE__*/_jsx("p", {
      className: "mt-0.5 truncate text-xs text-gray-500",
      children: t1
    });
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}
function _temp(f) {
  return f.label;
}